var _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBenefits01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 61,
    viewBox: "0 0 77 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.9816 23.5856L36.9999 9.2864C36.631 9.11614 36.206 9.11614 35.8371 9.2864L7.55276 22.3407C6.48343 22.8343 6.47659 24.3517 7.54142 24.8548L15.6077 28.6664M67.9816 23.5856H36.4185M67.9816 23.5856V41.2748M67.9816 23.5856L55.1483 29.6497M55.1483 29.6497L37.0113 38.22C36.636 38.3973 36.2011 38.3973 35.8258 38.22L15.6077 28.6664M55.1483 29.6497V40.403C55.1483 40.936 54.843 41.4218 54.3627 41.653L37.0319 49.9975C36.645 50.1838 36.1937 50.1804 35.8096 49.9884L16.3746 40.2709C15.9046 40.0359 15.6077 39.5555 15.6077 39.03V28.6664",
    stroke: "#00583E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 67.9815,
    cy: 45.0901,
    r: 3.16216,
    stroke: "#00583E",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefits01);
export default __webpack_public_path__ + "static/media/benefits_01.a90f7f31d014e76582c05597ddfb6268.svg";
export { ForwardRef as ReactComponent };